import { Skeleton, TableRow } from "@mui/material";
import { TableCellHeading } from "../../../pages/customer/CustomerTable";

export const TableRowsLoader = ({ rowsNum, colNum }: { rowsNum: number, colNum?: number }) => {
    const numberOfRows = Array.from({ length: rowsNum }, () => rowsNum)
    const numberOfColumn = colNum ? Array.from({ length: colNum }, () => colNum) : [1, 1, 1, 1, 1, 1, 1]

    const loader = numberOfRows.map((row: any, index: number) => <TableRow key={index} >
        {numberOfColumn.map((col: any, i: number) => <TableCellHeading component="th" scope="row" key={i}>
            <Skeleton animation="wave" variant="text" />
        </TableCellHeading>)}
    </TableRow>)

    return <>{loader}</>
};
